import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import OrderCancelConfirmModal from '../../../../views/order/common/modal/OrderCancelConfirmModal';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';

class CancelCompleteConfirmModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderItemList: props.data.orderItemList,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'cancelCompleteConfirmModal',
    });
  };

  setOrderItemList = (list) => {
    this.setState({ orderItemList: list });
  };

  onSubmit = () => {
    const { form, completeOrderCancel } = this.props;
    const { orderItemList } = this.state;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      completeOrderCancel({
        orderItemList: orderItemList.map((item) => ({
          isDisabledEdit: item.isDisabledEdit,
          orderItemId: item.orderItemId,
          productId: item.productId,
          productOptionId: item.productOptionId,
          newProductType: item.newProductType,
          newStockCount: item.newStockCount,
          newStatus: item.newStatus,
        })),
      });
    });
  };

  render() {
    const { form, isOpen, data } = this.props;

    return (
      <OrderCancelConfirmModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        setOrderItemList={this.setOrderItemList}
        onSubmit={this.onSubmit}
        okText="취소 완료"
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.cancelCompleteConfirmModal.isOpen,
    data: state.order.cancelCompleteConfirmModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  completeOrderCancel: orderActions.completeOrderCancel,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(CancelCompleteConfirmModalContainer)));
